import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";


function Payhead_Report() {

      const [noteType, setNoteType] = useState(null);
      const [fetchData, setfetchData] = useState([]);
      const [fromDate, setFromDate] = useState('');
      const [toDate, setToDate] = useState('');
      const [branchDetail, setBranchDetail] = useState([])
      const [bonusPercent, setBonusPercent] = useState(0);
      const [selectedDesignation, setSelectedDesignation] = useState('');
    
      const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
      const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
      };
    
    
      const reportOptions = [
         { value: 'bonus_statement', label: 'Bonus Statement' },
        { value: 'employee_payhead', label: 'Emplloyee Payhead' },
        { value: 'gratuaty', label: 'Gratuaty' },
           { value: 'labour_welfare_fund', label: 'Labour Welfare Fund' }, 
        { value: 'payhead_wise_statement', label: 'Payhead Wise Statement' }, 
         { value: 'payroll_to_bank', label: 'Payroll To Bank' }, 
          { value: 'payroll_v4', label: 'Payroll V4' },
           { value: 'deduction_exception', label: 'Deduction Exception Report' },
      ]


const handleSearch = async (e) => {
  e.preventDefault();

  if (!noteType?.value) {
    setToast('Please select a report type', 'warning');
    return;
  }

  try {
    const params = {
      noteType: noteType.value,
       from_date: fromDate,  
      to_date: toDate
    };

    const result = await axios.get(
      'https://api.skyguard.group/api/get-payhead-report',
      { params }
    );

    const resultData = result?.data?.result || [];
   
    setfetchData(resultData);

    if (resultData.length > 0) {
      setToast(
        noteType.value === 'employee_payhead' ? 
        'Employee Payhead report fetched successfully' : 
        'Gratuity report fetched successfully',
        'success'
      );
    } else {
      setToast('No data found', 'warning');
    }

  } catch (error) {
    console.error('❌ Error fetching report:', error);
    setToast('Error fetching report. Please try again.', 'danger');
  }
};




 const handleExportExcel = () => {
      const table = document.getElementById("exportTable");
    
      if (!table) return;
    
      const worksheet = XLSX.utils.table_to_sheet(table);
      const workbook = XLSX.utils.book_new();
    
      XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");
    
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
    
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
    
      saveAs(data, "Payhead_Report.xlsx");
    };

const payheadKeys = React.useMemo(() => {
  const keys = new Set();
  fetchData.forEach(item => {
    if (item.payhead_data) {
      const payheads = JSON.parse(item.payhead_data); 
      payheads.forEach(ph => keys.add(ph.name));
    }
  });
  return Array.from(keys);
}, [fetchData]);


const normalizedData = fetchData.map(emp => {
  let payheads = [];

  try {
    payheads =
      typeof emp.payheads === 'string'
        ? JSON.parse(emp.payheads)
        : emp.payheads || [];
  } catch (e) {
    payheads = [];
  }

  return {
    ...emp,
    payheads
  };
});



const payheadColumnNames = [
  ...new Set(
    normalizedData.flatMap(emp =>
      emp.payheads.map(p => p.name)
    )
  )
];




const parseJSON = (data) => {
  try {
    return typeof data === "string" ? JSON.parse(data) : data || [];
  } catch {
    return [];
  }
};

const getTotal = (arr) =>
  arr.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);


const headColumnNames = [
  ...new Set(
    fetchData.flatMap(item => {
      const payheads = parseJSON(item.payheads);
      return payheads.map(p => p.name);
    })
  )
];

  return (
   <>
      <div className='main-section'>
         <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
            <h3 className='my-3 fw-bold fs-5 golos'>Payhead Report</h3>

            <div className="row g-3 align-items-end">
            <div className="col-md-4">
              <label className='fw-bold'>Select Report</label>
              <Select
                options={reportOptions}
                placeholder="Choose Type ..."
                id="source"
                value={noteType}

                onChange={(selected) => {
                  setNoteType(selected);
                  setfetchData([]);
                }}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>From Date</label>
              <input
                type="month"
                className="form-control"
                name="from_date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>To Date</label>
              <input
                type="month"
                className="form-control"
                name="to_date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>


            <div className="col-md-12 d-flex justify-content-end align-items-end">
              {/* <button className="btn btn-primary" onClick={handleSearch} >Search</button> */}
               <FaSearch size={26} className="ms-1 text-primary"
                              style={{ cursor: "pointer" }}
                              title="Search"
                              onClick={handleSearch}
                            />
              
                            <MdLocalPrintshop
                              size={26}
                              className="ms-1 text-success"
                                 onClick={handleExportExcel}
                              style={{ cursor: "pointer" }}
                              title="Print "
                            />
            </div>
          </div>


          {noteType?.value === 'payroll_v4' && (
  <div className="col-md-3 mb-2">
    <label className="fw-bold">Designation</label>
    <select
      className="form-control"
      value={selectedDesignation}
      onChange={(e) => setSelectedDesignation(e.target.value)}
    >
      <option value="">All</option>

      {[...new Set(fetchData.map(item => item.designation))].map((des, i) => (
        <option key={i} value={des}>
          {des}
        </option>
      ))}
    </select>
  </div>
)}

           <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                {noteType?.value === 'employee_payhead' && (
              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>Employee</th>
                    <th>Basic Salary</th>
                      {payheadKeys.map((key, idx) => (
      <th key={idx}>{key}</th>
    ))}
                    
                  </tr>
                </thead>
               <tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
      const payheads = JSON.parse(item.payhead_data); 
      const payheadMap = {};
      payheads.forEach(ph => {
        payheadMap[ph.name] = ph.amount;
      });

      return (
        <tr key={idx}>
          <td>{item.emp_id} - {item.emp_name}</td>
          <td>{item.salary}</td>
          {payheadKeys.map((key, kIdx) => (
            <td key={kIdx}>{payheadMap[key] || 0}</td>
          ))}
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={2 + payheadKeys.length}>No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}

  {noteType?.value === 'gratuaty' && (
    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'> 
        <h5 className='text-center text-primary mt-2'>Gratuaty @15 Days Basic for Every Completed Year </h5> 
         <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>Employee Code</th>
                    <th>Employee Name</th>
                    <th>DOJ </th>
                    <th>Seperation Date</th>
                    <th>Basic</th>
                    <th>Year Of Service</th>
                    <th>Gratuaty</th>   
                  </tr>
                </thead>
                 <tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => (
      <tr key={idx}>
        <td>{item.emp_id} </td>
        <td>{item.first} {item.middle} {item.last} </td>
        <td>{item.doj}</td>
        <td>{item.seperation_date || '-'}</td>
        <td>{item.basic} </td>
        <td>{item.years_of_service ?? '-'}</td>
        <td>{item.gratuity !== null ? item.gratuity.toFixed(2) : '-'}</td>
       
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6">No data found</td>
    </tr>
  )}
</tbody>
              </table>
    </div>
             
            )}

{noteType?.value === 'bonus_statement' && (
  <div className="mb-3">
    <label>Enter Bonus %:</label>
    <input
      type="number"
      className="form-control w-auto d-inline-block ms-2"
      value={bonusPercent}
      onChange={(e) => setBonusPercent(Number(e.target.value))}
      min="0"
    />
  </div>
)}         



  {noteType?.value === 'bonus_statement' && (
  <table className='table table-bordered table-striped table-hover text-center align-middle'>
    <thead className='table-info'>
      <tr>
        <th>Employee</th>
        <th>Name</th>
        <th>Yearly Salary</th>
        <th>Bonus ({bonusPercent}%)</th> {/* New column */}
        {payheadKeys.map((key, idx) => (
          <th key={idx}>{key}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {Array.isArray(fetchData) && fetchData.length > 0 ? (
        fetchData.map((item, idx) => {
          const bonus = ((item.basic*12 || 0) * bonusPercent) / 100; // calculate bonus dynamically
          return (
            <tr key={idx}>
              <td>{item.emp_id}</td>
              <td>{item.first} {item.middle} {item.last}</td>
              <td>{item.basic * 12}</td>
              <td>{bonus.toFixed(2)}</td> 
              {payheadKeys.map((key, idx2) => (
                <td key={idx2}>{item[key]}</td>
              ))}
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={4 + payheadKeys.length}>No data found</td>
        </tr>
      )}
    </tbody>
  </table>
)}          


{noteType?.value === 'payhead_wise_statement' && (
  <table className='table table-bordered table-striped table-hover text-center align-middle'>
    
    <thead className='table-info'>
      <tr>
        <th>Employee</th>
        <th>Name</th>
        <th>Basic Salary</th>
        <th>Payroll Month</th>

        {payheadColumnNames.map((name, idx) => (
          <th key={idx}>{name}</th>
        ))}
      </tr>
    </thead>

    <tbody>
      {/* {Array.isArray(fetchData) && fetchData.length > 0 ? (
        fetchData.map((item, idx) => {

          // ✅ PARSE PAYHEADS PER ROW
          let payheads = [];

          try {
            payheads =
              typeof item.payhead_data === 'string'
                ? JSON.parse(item.payhead_data)
                : item.payhead_data || [];
          } catch (e) {
            payheads = [];
          }

          return (
            <tr key={idx}>
              <td>{item.emp_id}</td>
              <td>{item.emp_name}</td>
              <td>{item.basic_salary}</td>

              {payheadColumnNames.map((name, idx2) => {

                const match = payheads.find(p => p.name === name);

                return (
                  <td key={idx2}>
                    {match ? match.amount : 0}
                  </td>
                );
              })}
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={3 + payheadColumnNames.length}>
            No data found
          </td>
        </tr>
      )} */}

      {normalizedData.map((item, idx) => (
  <tr key={idx}>
    <td>{item.emp_id}</td>
    <td>{item.emp_name}</td>
    <td>{item.basic_salary}</td>
    <td>{item.month} </td>

    {payheadColumnNames.map((name, idx2) => {
      const match = item.payheads.find(p => p.name === name);

      return (
        <td key={idx2}>
          {match ? match.amount : 0}
        </td>
      );
    })}
  </tr>
))}
    </tbody>
  </table>
)}

  {noteType?.value === 'payroll_to_bank' && (
  <table className='table table-bordered table-striped table-hover text-center align-middle'>
    <thead className='table-info'>
      <tr>
        <th>Employee</th>
        <th>Name</th>
      
        <th>Payroll Month</th>
        <th>Acc No.</th>
          <th>Net alary</th>
      </tr>
    </thead>
    <tbody>
      {Array.isArray(fetchData) && fetchData.length > 0 ? (
        fetchData.map((item, idx) => {
      
          return (
            <tr key={idx}>
              <td>{item.emp_id}</td>
              <td>{item.emp_name}</td>
              <td>{item.month} </td>
              <td>{item.bank_acc}</td>
              <td>{item.net_salary} </td>
              
             
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={4 + payheadKeys.length}>No data found</td>
        </tr>
      )}
    </tbody>
  </table>
)} 

  {noteType?.value === 'payroll_v4' && (
  <table className='table table-bordered table-striped table-hover text-center align-middle'>
    <thead className='table-info'>
      <tr>
        <th>Employee</th>
        <th>Name</th>
        <th>ESIC</th>
        <th>Designation</th>
        <th>Payroll Month</th>
        <th>Preset Days</th>
        <th>Absent Days</th>
        <th>Basic Salary </th>
       <th>Addional Earning</th>
       <th>Deduction</th>
          <th>Net alary</th>
          {headColumnNames.map((name, idx) => (
  <th key={idx}>{name}</th>
))}
      </tr>
    </thead>
    <tbody>
      {Array.isArray(fetchData) && fetchData.length > 0 ? (
       fetchData.filter(item =>
    !selectedDesignation || item.designation === selectedDesignation
  ).map((item, idx) => {

  const earningsArr = parseJSON(item.additional_earnings);
  const deductionArr = parseJSON(item.deductions);
  // const heads = getAllHeads(item);
  const payheads = parseJSON(item.payheads);

  const totalEarnings = getTotal(earningsArr);
  const totalDeductions = getTotal(deductionArr);

  return (
    <tr key={idx}>
      <td>{item.emp_id}</td>
      <td>{item.emp_name}</td>
      <td>{item.esic}</td>
      <td>{item.designation} </td>
      <td>{item.month}</td>
      <td>{item.paid_days}</td>
      <td>{item.absent_days}</td>
      <td>{item.basic_salary}</td>

  
      <td>{totalEarnings}</td>
      <td>{totalDeductions}</td>

    
      <td>{item.net_salary}</td>

  
      {headColumnNames.map((name, i) => {
       const match = payheads.find(p => p.name === name);

        return (
          <td key={i}>
            {match ? match.amount : 0}
          </td>
        );
      })}
    </tr>
  );
})
      ) : (
        <tr>
          <td colSpan='10'>No data found</td>
        </tr>
      )}
    </tbody>
  </table>
)} 


  {noteType?.value === 'labour_welfare_fund' && (
  <table className='table table-bordered table-striped table-hover text-center align-middle'>
    <thead className='table-info'>
      <tr>
        <th>Employee</th>
        <th>Name</th>
      <th>Payhead Name</th>
      <th>Amount</th>
      </tr>
    </thead>
    <tbody>
     {Array.isArray(fetchData) && fetchData.length > 0 ? (
  fetchData
    .map((item, idx) => {

      let payheads = [];

      try {
        payheads =
          typeof item.payhead_data === "string"
            ? JSON.parse(item.payhead_data)
            : item.payhead_data || [];
      } catch {
        payheads = [];
      }

      // ✅ FIND MATCHING PAYHEAD
      const match = payheads.find(
        p => p.name?.toLowerCase() === "labour welfare fund"
      );

      // ❌ skip if not found
      if (!match) return null;

      return (
        <tr key={idx}>
          <td>{item.emp_id}</td>
          <td>{item.emp_name}</td>
          <td>{match.name}</td>
          <td>{match.amount}</td> {/* ✅ SHOW AMOUNT */}
        </tr>
      );
    })
    .filter(Boolean) // remove null rows
) : (
  <tr>
    <td colSpan={4}>No data found</td>
  </tr>
)}
    </tbody>
  </table>
)} 


{noteType?.value === 'deduction_exception' && (
  <table className='table table-bordered table-striped text-center'>
    
    <thead className='table-info'>
      <tr>
        <th>Employee ID</th>
        <th>Name</th>
        <th>Month</th>
        <th>Missing Deductions</th>
      </tr>
    </thead>

    <tbody>
      {Array.isArray(fetchData) && fetchData.length > 0 ? (
        fetchData.map((item, idx) => (
          <tr key={idx}>
            <td>{item.emp_id}</td>
            <td>{item.emp_name}</td>
            <td>{item.month}</td>

            <td>
              {Array.isArray(item.missing_deductions)
                ? item.missing_deductions.join(", ")
                : ""}
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="4">No data found</td>
        </tr>
      )}
    </tbody>

  </table>
)}


           </div>
        </div>
      </div>
   </>
  )
}

export default Payhead_Report